import React,{Component} from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Button,

    InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,
  DatePicker,
 } from "shards-react";
import PageTitle from "../common/PageTitle";
import AddHomeWork from './AddHomeWork';
import ViewHomeWork from './ViewHomeWork';
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';
import { Redirect } from 'react-router';

export default class Class extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
      add_homework : false,
      class_list:[],
      selected_class:"Select Class",
      selected_date:new Date(),
      loading:false,
      homework_data:[],
      fetched:false,
      logged_in:false,
    };

    this.ShowViewHomeWork = this.ShowViewHomeWork.bind(this);
    this.ShowAddHomeWork  = this.ShowAddHomeWork.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.get_data = this.get_data.bind(this);
  }

  get_class_list = ()=>{
      var that = this;
      this.setState({loading:true});
      firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          that.setState({loading:false,class_list:class_list});
      }).catch(function(err){
          that.setState({loading:false});
          toast('Unable to get class list !', {containerId: 'A'});
      })
  }

  componentDidMount(){
    this.get_class_list();
   
  }

  ShowViewHomeWork = () =>{
    this.setState({add_homework:false});
  }

  ShowAddHomeWork = () =>{
    this.setState({add_homework:true});
  }

  stateChangeHandler=(data)=>{
    this.setState(data);

  }

  handleStartDateChange(value) {
    this.setState({
      ...this.state,
      ...{ selected_date: new Date(value) }
    },this.get_data);

  }


  convertDate = (date)=>{

    var dd = date.getDate();
      var mm = date.getMonth();
      var yyyy = date.getFullYear();

      if(dd<10){
        dd = "0"+dd;
      }
      if(mm<10){
        mm = "0"+mm;
      }

      return yyyy+"-"+mm+"-"+dd;

  }

  get_data= ()=>{

      var that = this;

      if(!this.state.selected_class!=="Select Class"){
            
            this.setState({loading:true,fetched:false});
            var date_string = this.convertDate(this.state.selected_date);
            var code = date_string+":"+this.state.selected_class;
            firebase.firestore().collection('HomeWork').doc(code).get().then(function(doc){

                if(doc.exists){
                    that.setState({homework_data:doc.data().list});
                    that.setState({loading:false,fetched:true});
                }
                else{

                  that.setState({loading:false,fetched:true,homework_data:[]});
                }
            }).catch(function(error){
                console.log(error.message);
                that.setState({loading:false,fetched:true,homework_data:[]});
            })
      }
  }

  deletehomework = (classname,id)=>{


      var date = this.convertDate(this.state.selected_date);      
      var that = this;      
      var func_ref = firebase.functions().httpsCallable('RemoveHomeWork');  
        
      var data={
        date:date,
        id:id,
        class_name:classname
      }

       

      var r = window.confirm("Delete Homwork id "+id);
      
      if (!r) {
            return;
        }

        this.setState({loading:true});    
        func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully removed!");
                        that.get_data();
                        toast('HomeWork  Removed Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable Remove HomeWork", {containerId: 'A'});
        });
  }

  componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }



	render(){

    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

			return (
					<Container fluid className="main-content-container px-4">

						 {/* Page Header */}
    					<Row noGutters className="page-header py-4">
      									<PageTitle sm="6" title="HomeWork" subtitle="All" className="text-sm-left" />
    					</Row>

              <div style={{marginLeft: '80%'}}>
                          <Row>
                          {   (!this.state.loading && this.state.add_homework) &&
                            <Button size="lg" theme="info" className="mb-2 mr-1" style={{margin:"3%",borderRadius: 70}} onClick={()=>this.ShowViewHomeWork()}>
                                    View HomeWork
                                </Button>
                          }
                          { ( !this.state.loading && !this.state.add_homework) && 
                                <Button size="lg" theme="success" className="mb-2 mr-2" style={{margin:"3%",borderRadius: 50}} onClick={()=>this.ShowAddHomeWork()}>
                                    Add HomeWork
                                </Button>
                          }
                              </Row>
                        </div>
                        
 						<Col>
        					<Card small className="mb-4">
        						  
                      
                  
                    <CardHeader className="border-bottom">
        								  
                          HomeWork
          						</CardHeader>
        					 	
                  
                    <CardBody className={"p-0 pb-3 "+(this.state.add_homework?"":"scroll_list-group")}>

                    {
                      !this.state.add_homework &&

                      <SelectClassDate 
                          select_class ={(evt)=>{this.setState({selected_class:evt.target.value},this.get_data)}}
                          handleStartDateChange={this.handleStartDateChange}
                          selected_date = {this.state.selected_date}
                          loading={this.props.loading}
                          class_list={this.state.class_list}
                      />

                  }
        								  
                    { ( !this.state.loading && this.state.add_homework) &&
        								<div style={{height: '50%',width: '50%',marginLeft:"25%",borderWidth: 5,borderColor: 'black'}}>
        							 		<AddHomeWork cancel={()=>this.ShowViewHomeWork()} class_list={this.state.class_list}/>
              					</div>
              			}	
                     {  ( !this.state.loading && !this.state.add_homework && this.state.fetched && !(this.state.homework_data.length===0)) && 
              							<div>
              								<ViewHomeWork  data={this.state.homework_data} deletehw={this.deletehomework}/>
              							</div>
              			}

                    {
                      (!this.state.loading && !this.state.add_homework && this.state.selected_class==="Select Class") &&

                        <div style={{marginTop: '8%'}} className="text-muted">
                            <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                                  {"Please Select Class"}
                            </div>
                            <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                                 <i class="material-icons">call_missed</i>  
                            </div>                  
                        </div>
          
                      }	

                      {
                      (!this.state.loading && !this.state.add_homework && this.state.fetched && (this.state.homework_data.length===0) ) &&

                        <div style={{marginTop: '5%'}} className="text-muted">
                            <div  style={{fontSize:30,textAlign: 'center',color:'blue' }}>
                                  {" No HomeWork Avaiable on  "+this.state.selected_date.toString().slice(0,15)}
                            </div>
                            <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                                 <i class="material-icons">airline_seat_flat</i>  
                            </div>                  
                        </div>
          
                      } 


                     {
                        (this.state.loading) &&
                          <div style={{margin: '10%',marginLeft: '40%'}}>
                              <AtomSpinner color="blue" />            
                          </div>
                      }		
        						</CardBody>
          					

                    </Card>
          				</Col>



					</Container>

			)
		}

}





class SelectClassDate extends Component{
  render(){
    return(


      <Row className="border-bottom py-2 bg-light">
            <Col sm="12" className="d-flex mb-2 mb-sm-0">
              <Col md="4" className="form-group">
            
             <FormSelect onChange={this.props.select_class}>
                  <option>{this.props.loading?"Loading...":(this.props.class_list.length>0?"Select Class":"No Classes Available")}</option>
                                          {

                                              this.props.class_list.map((item,i)=>{
                                                             return (<option key={i}>{item}</option>)
                                                })
                                           }
            </FormSelect>
            </Col>

              <Col>
              <InputGroup>
                  <DatePicker
                  size="ld"
                  selected={this.props.selected_date}
                  onChange={this.props.handleStartDateChange}
                  placeholderText="Pick Date"
                  dropdownMode="select"
                  className="text-center"
              />
              <InputGroupAddon type="append">
                  <InputGroupText>
                    <i className="material-icons">&#xE916;</i>
                  </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
            </Col>
                        
            </Col>
            
          </Row>




      )
  }
}